// Renders a view for the student while the exam is provisioned

import React from 'react';
import { observer } from 'mobx-react';

// Config
import { setToken } from '../../config';

// Translation
import translate from '../Translate';

const ProvisionExam = observer(
  class ProvisionExam extends React.Component {
    componentDidMount() {
      const { ProctorStore } = this.props.store;

      // This gets the query params, if any, from the url
      // Extract query string from hash (e.g., /#/provision?param=value)
      const queryString = window.location.hash.includes('?') 
        ? window.location.hash.split('?')[1] 
        : window.location.search.substring(1);
      const params = new Proxy(new URLSearchParams(queryString), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      
      const examSid = params.exam_sid || params.examSid || sessionStorage.getItem('examSid');
      const installSid = params.install_sid || params.installSid || sessionStorage.getItem('installSid');
      const sessionSid = params.session_sid || params.sessionSid || sessionStorage.getItem('sessionSid');

      const data = {
        examSid,
        installSid,
        sessionSid,
        status: 'Checked In'
      };

      const callback = url => {
        window.location.href = url;
      };

      // If there is a token in sessionStorage, make sure
      // we are using it for API calls. (This may be redundant).
      if (sessionStorage.getItem('token')) {
        setToken(sessionStorage.getItem('token'), true);
      }

      ProctorStore.provisionOnlineSession(data, callback);
    }

    render() {
      const { translation } = this.props;

      return (
        <main className="page wrap">
          <div className="panel--brief">
            <h1 className="panel__title">{translation.heading}</h1>
            <p className="form-brief">{translation.message}</p>
          </div>
        </main>
      );
    }
  }
);

export default translate('ProvisionExam')(ProvisionExam);



// WEBPACK FOOTER //
// ./src/app/components/provision/ProvisionExam.js